import { render, staticRenderFns } from "./MainLocation.vue?vue&type=template&id=9a54fb7c&scoped=true&"
import script from "./MainLocation.vue?vue&type=script&lang=js&"
export * from "./MainLocation.vue?vue&type=script&lang=js&"
import style0 from "./MainLocation.vue?vue&type=style&index=0&id=9a54fb7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a54fb7c",
  null
  
)

export default component.exports